import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import LocalGasStationRoundedIcon from '@mui/icons-material/LocalGasStationRounded';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import BackHandRoundedIcon from '@mui/icons-material/BackHandRounded';
import BalanceRoundedIcon from '@mui/icons-material/BalanceRounded';
import LocalParkingRoundedIcon from '@mui/icons-material/LocalParkingRounded';
import TireRepairRoundedIcon from '@mui/icons-material/TireRepairRounded';

import CorporateFareRoundedIcon from '@mui/icons-material/CorporateFareRounded';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import BathroomRoundedIcon from '@mui/icons-material/BathroomRounded';
import BeenhereRoundedIcon from '@mui/icons-material/BeenhereRounded';
import LocalCarWashRoundedIcon from '@mui/icons-material/LocalCarWashRounded';

import AgricultureRoundedIcon from '@mui/icons-material/AgricultureRounded';
import AirportShuttleRoundedIcon from '@mui/icons-material/AirportShuttleRounded';
import DeliveryDiningRoundedIcon from '@mui/icons-material/DeliveryDiningRounded';
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded';
import Man2RoundedIcon from '@mui/icons-material/Man2Rounded';
const iconArr = [
    BusinessRoundedIcon,
    LocalGasStationRoundedIcon,
    ConstructionRoundedIcon,
    BackHandRoundedIcon,
    BalanceRoundedIcon,
    LocalParkingRoundedIcon,
    TireRepairRoundedIcon,
    CorporateFareRoundedIcon,
    WarehouseIcon,
    BathroomRoundedIcon,
    BeenhereRoundedIcon,
    LocalCarWashRoundedIcon,
    AgricultureRoundedIcon,
    AirportShuttleRoundedIcon,
    DeliveryDiningRoundedIcon,
    LocalShippingRoundedIcon,
    Man2RoundedIcon,
    //!!!внимание!!! новые иконки добавлять только в конец списка, 
    //что уже выбранные пользователем для своих целей иконки не "поехали"
];

export default iconArr;